import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class LeaderboardEntry extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "points", Model.attribute('points'));
    _defineProperty(this, "rank", Model.attribute('rank'));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'common/models/LeaderboardEntry', LeaderboardEntry);